import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Pagination,

} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoEatery from "../../assets/images/logoDashboard.png";
import { makeRequest } from "../../assets/functions_helper";

const SelectRestaurantPopup = ({ open, setOpen, onSelect }) => {
  const navigate = useNavigate();
  const [restaurants, setRestaurants] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [totalPages, setTotalPages] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedRestaurant, setSelectedRestaurant] = React.useState(null);

  const fetchRestaurants = React.useCallback(
    (page = 1) => {
      // Construcción de la URL con el nuevo endpoint y tamaño 10
      let url = `restaurant_admin/list_my_restaurants?page=${page}&size=10&order_by=id&order=desc`;

      // Si el usuario no es admin, podrías mantener la lógica anterior,
      // pero según el requerimiento usamos siempre el nuevo endpoint.
      // Si aún necesitas soportar otros roles, descomenta las líneas siguientes:
      // if (localStorage.getItem("rol") === "2") {
      //   url = `restaurant_admin/list_my_restaurants?page=${page}&size=10&order_by=id&order=desc`;
      // } else {
      //   url = `restaurants/?page=${page}&size=10&order_by=id&order=desc`;
      // }

      // Verificación de token
      if (!localStorage.getItem("rol")) {
        localStorage.clear();
        navigate("/login");
        return;
      }

      makeRequest(
        "GET",
        url,
        {},
        "application/json",
        localStorage.getItem("token"),
        localStorage.getItem("tokenType"),
        null,
        null,
        () => {
          navigate("/login");
        }
      ).then((response) => {
        // Adaptar los datos para mostrar título e ID
        const updateRestaurants = response.restaurants.map((restaurant) => ({
          ...restaurant,
          title: restaurant.name,
          title2: `ID: ${restaurant.id}`,
        }));
        setRestaurants(updateRestaurants);
        setTotalPages(response.pages || 1);
        setCurrentPage(response.current_page || page);
        setIsLoaded(true);
      });
    },
    [navigate]
  );

  // Cargar restaurantes cada vez que se abre el popup
  React.useEffect(() => {
    if (open) {
      setIsLoaded(false);
      fetchRestaurants(currentPage);
    }
  }, [open, fetchRestaurants, currentPage]); // Solo depende de open, no de currentPage

  const handlePageChange = (_, page) => {
    setCurrentPage(page);
    setIsLoaded(false);
    fetchRestaurants(page);
  };

  const handleSelectRestaurant = (restaurant) => {
    setSelectedRestaurant(restaurant);
    localStorage.setItem("selectedRestaurantId", restaurant.id);
    localStorage.setItem("selectedRestaurantName", restaurant.name);
    
    // Obtener public_id para el nuevo endpoint
    makeRequest(
      "GET",
      `restaurants/restaurant/info?restaurant_id=${restaurant.id}`,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      true
    )
      .then((data) => {
        if (data && data.public_id) {
          localStorage.setItem("restaurant_public_id", data.public_id);
        }
      })
      .catch((err) => console.error("Error fetching restaurant info for public_id:", err))
      .finally(() => {
        if (onSelect) onSelect(restaurant);
        if (setOpen) setOpen(false);
        // Refrescar completamente para que los componentes re-lean el localStorage y reseteen sus estados.
        window.location.reload();
      });
  };

  return (
    <>
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Evita cierre por click fuera o tecla ESC
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          backgroundColor: "#fff",
          p: "16px",
          maxWidth: "760px",
        },
      }}
    >
      <DialogContent>
        {/* Logo */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          <img
            src={LogoEatery}
            alt="Logo"
            style={{ width: 150, height: "auto" }}
          />
        </Box>

        {/* Títulos */}
        <Typography
          align="center"
          sx={{
            fontFamily: "Como, sans-serif",
            fontWeight: 700,
            fontSize: 22,
            color: "#1E1E1E",
          }}
        >
          Selecciona tu restaurante
        </Typography>

        <Typography
          align="center"
          sx={{
            fontFamily: "Como, sans-serif",
            fontWeight: 400,
            fontSize: 15,
            color: "#777",
            mb: 4,
          }}
        >
          ¿A cuál restaurante deseas ingresar?
        </Typography>

        {/* Lista de restaurantes */}
        {!isLoaded ? null : (
          <Grid container spacing={2}>
            {restaurants.map((restaurant) => (
              <Grid item xs={12} sm={6} key={restaurant.id}>
                <Card
                  onClick={() => handleSelectRestaurant(restaurant)}
                  sx={{
                    width: 312,
                    height: 57,
                    margin: "0 auto",
                    borderRadius: "16px",
                    border: "1px solid #D8D8D8",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    backgroundColor:
                      selectedRestaurant?.id === restaurant.id
                        ? "#F5F5FF"
                        : "#fff",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      height: "100%",
                      py: "6px !important",
                      px: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Como, sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#1E1E1E",
                      }}
                    >
                      {restaurant.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Como, sans-serif",
                        fontWeight: 400,
                        fontSize: 13,
                        color: "#777",
                      }}
                    >
                      {restaurant.title2}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* Paginación */}
        {isLoaded && totalPages > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              sx={{
                "& .MuiPaginationItem-root": {
                  fontFamily: "Como, sans-serif",
                },
              }}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  </>
  );
};

export default SelectRestaurantPopup;